import { COLORS } from "shared/consts";
import { toRem } from "shared/helpers";
import styled from "styled-components";

export const VetisAccessText = styled.div`
  p {
    &:not(:last-child) {margin-bottom: ${toRem(12)};}
  }

  a {
    color: ${COLORS.ACCENT.DEFAULT};
    @media (any-hover: hover){
      &:hover{
        text-decoration: underline;
      }
    }
  }
`;



export const NewEntrieWrapper = styled.form`
  min-height: 100%;
  display: flex;
  flex-direction: column;

  @media (width < ${toRem(768)}) {
    width: 100vw;
  }
`;

type NewEntrieHeadProps = {
  $isMobile?: boolean;
};
export const NewEntrieHead = styled.div<NewEntrieHeadProps>`
  padding: ${toRem(16)};
  display: flex;
  flex-direction: ${(props) => (props.$isMobile ? "row-reverse" : "column")};
  gap: ${toRem(12)};
  justify-content: space-between;
  align-items: ${(props) => (props.$isMobile ? "center" : "initial")};
`;

export const NewEntrieTitle = styled.h2`
  display: flex;
  gap: ${toRem(12)};
  justify-content: space-between;
  font-weight: 700;
  font-size: ${toRem(22)};
  line-height: ${24 / 22};
  color: ${COLORS.FG.DEFAULT};

  @media (width < ${toRem(768)}) {
    font-size: ${toRem(16)};
  }

  button {
    color: ${COLORS.ACCENT.DEFAULT};
    font-size: ${toRem(16)};
  }
`;

export const NewEntrieBody = styled.div`
  padding: ${toRem(16)};
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;

  @media (width >= ${toRem(540)}) {
    width: ${toRem(540)};
  }
  @media (width < ${toRem(540)}) {
    width: 100vw;
  }
`;

export const NewEntrieSubTitle = styled.h3`
  font-weight: 700;
  font-size: ${toRem(16)};
  line-height: ${20 / 16};
  padding: ${toRem(14)} 0;
`;

type NewEntrieRowProps = {
  $alignItems?: React.CSSProperties["alignItems"];
};
export const NewEntrieRow = styled.div<NewEntrieRowProps>`
  display: flex;
  align-items: ${(props) => props.$alignItems || "center"};
  gap: ${toRem(12)};
  margin: ${toRem(6)} 0;
  position: relative;

  .popover__root input {
    text-transform: capitalize;
  }

  &,
  & > * {
    max-width: 100%;
    text-overflow: ellipsis;
    &:not(:has(.dropdown-menu)):not(:has(.taggroup)):not(._has-overflow) {
      overflow: hidden;
    }
  }
  & .tagitem.tagitem--primary[aria-invalid="true"] {
    background-color: ${COLORS.BG.SURFACE1} !important;
  }

  & .tagitem.tagitem--primary[aria-invalid="true"] .tagitem__label {
    color: ${COLORS.FG.DEFAULT} !important;
  }

  > span {
    flex: 0 0 ${toRem(145)};
    font-weight: 500;
    font-size: ${toRem(14)};
    line-height: ${20 / 14};
  }

  @media (width >= ${toRem(540)}) {
    .popover__root,
    .dropdown-menu-root,
    .input  {
      min-width: ${toRem(220)};
      max-width: ${toRem(220)};
    }
  }

  .tagitem__label {
    display: flex;
    align-items: center;
    gap: ${toRem(8)};

    img {
      max-width: ${toRem(20)};
      aspect-ratio: 1;
      border-radius: 50%;
    }
  }

  i {
    color: ${COLORS.FG.MUTED};
  }
`;

export const NewEntrieBorder = styled.div`
  width: 100%;
  height: ${toRem(1)};
  margin: ${toRem(6)} 0;
  background-color: ${COLORS.BORDER.MUTED};
`;

export const NewEntrieFooter = styled.div`
  padding: ${toRem(12)} ${toRem(16)};
  border-top: ${toRem(1)} solid ${COLORS.BORDER.SOFT};
  display: flex;
  gap: ${toRem(16)};

  @media (width < ${toRem(768)}) {
    display: flex;
    flex-direction: column-reverse;
    gap: ${toRem(12)};
  }
`;

type NewEntrieTextAreaWrapperProps = {
  $height?: string;
};
export const NewEntrieTextAreaWrapper = styled.div<NewEntrieTextAreaWrapperProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${toRem(4)};
  flex: 1 1 auto;
  border: ${toRem(2)} solid transparent;
  background-color: ${COLORS.NEUTRAL.CONTAINER_DEFAULT};
  border-radius: ${toRem(8)};

  &:hover,
  &:focus-within {
    border-color: ${COLORS.ACCENT.DEFAULT};
    background-color: ${COLORS.BG.SURFACE1};
  }

  textarea {
    resize: none;
    height: ${(props) => props.$height || toRem(76)};
    padding: ${toRem(8)} ${toRem(12)};
    transition: all 0.3s ease 0s;
    font-size: ${toRem(14)};
    padding: ${toRem(9)};
    outline: none;
  }

  &~.input__hint {
    color: var(--input-primary-hint-color-error);
    font: var(--input-m-hint-font);
    margin-top: var(--input-m-labeloutside-spacing);
    padding-left: var(--input-m-hint-padding-left);
    padding-right: var(--input-m-hint-padding-right);
    display: flex;
    justify-content: space-between;
    gap: var(--input-m-counter-spacing);
  }
`;